import { DownloadOutlined, FileOutlined } from '@ant-design/icons';
import { Button, Card } from 'antd';

import { handleBlobDownload } from './helpers';

function ContentFile({ fileName, fileUrl }) {
  return (
    <Card>
      <div className="gx-d-flex gx-align-items-center gx-justify-content-between">
        <div className="gx-d-flex gx-fit-text gx-align-items-center">
          <FileOutlined />
          <div className="gx-ml-2">{fileName}</div>
        </div>
        <Button
          type="link"
          icon={<DownloadOutlined className="gx-fs-xl" />}
          onClick={() => handleBlobDownload(fileUrl, fileName)}
        />
      </div>
    </Card>
  );
}
export default ContentFile;
